import React from 'react';
import { AdditionalPrice } from '../AdditionalPrice';

export const AbonnementPrice = ({
  abonnementPrice,
  abonnementPriceLabel,
  displayEmptyLines,
  currency,
  currencyFirst,
}: any) => {
  return (
    <AdditionalPrice
      name="abonnementPrice"
      display={abonnementPrice}
      displayEmptyLines={displayEmptyLines}
    >
      +&nbsp;{currencyFirst && currency}
      {abonnementPrice}&nbsp;
      {!currencyFirst && currency} {abonnementPriceLabel}
    </AdditionalPrice>
  );
};
